import React, { useEffect, useState } from 'react'
import { ComposableMap, Geographies, Geography, Marker, ZoomableGroup } from 'react-simple-maps'
import MouseTooltip from 'react-sticky-mouse-tooltip'
import { useSelector } from 'react-redux'

let usCities = []
import('../../../resources/uscities.json')
.then(cities => {
    usCities = Object.values(cities.default)
})
  
  // url to a valid topojson file
const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json"

const INITIAL_STATE = {
    markerTooltip: "",
    mouseTooltipActive: false,
    cityMarkers: [],
    cityDictionary: {},
    cityMarkerVals: {},
}

function USAMap({ cityMetrics, onComplete }){
    const [state, setState] = useState(INITIAL_STATE)
    const [position, setPosition] = useState({ coordinates: [0, 0], zoom: 1 });

    const useDarkMode = useSelector(state => state.session.useDarkMode)

    function handleZoomIn() {
        if (position.zoom >= 4) return;
        setPosition((pos) => ({ ...pos, zoom: pos.zoom * 2 }));
      }
    
    function handleZoomOut() {
        if (position.zoom <= 1) return;
        setPosition((pos) => ({ ...pos, zoom: pos.zoom / 2 }));
    }

    function handleMoveEnd(position) {
        setPosition(position);
    }

    useEffect(() => {

        let cityMarkers = []
        let cityDictionary = {...state.cityDictionary}
        let cityMarkerVals = {}

        if(cityMetrics?.length > 0 && usCities && usCities?.length > 0){
            cityMetrics?.filter(v => v.value > 0).forEach(c => {
                const cityRegion = `${c.city}, ${c.region}`
                if(!cityDictionary[cityRegion]){
                    const item = usCities ? usCities?.find(p => p.city_ascii === c.city && p.state_name === c.region) : null
                    if(item){
                        cityMarkers.push({
                            ...c,
                            lat: item.lat,
                            lng: item.lng,
                            name: cityRegion
                        })
                        cityDictionary[cityRegion] = item
                    }
                } else {
                    cityMarkers.push({
                        name: cityRegion,
                        sessions: c.sessions,
                        lat: cityDictionary[cityRegion].lat,
                        lng: cityDictionary[cityRegion].lng,
                        value: c.value
                    })
                }
            })

        }     

        cityMarkerVals = cityMarkers.reduce((prev, curr, idx, arr) => {
            prev.sum += curr.value
            if(prev.count[curr.value] === undefined){
                prev.count[curr.value] = 0
            }

            prev.count[curr.value] ++

            if(curr.value > prev.max){
                prev.max = curr.value
            }
            if(curr.value < prev.min){
                prev.min = curr.value
            }

            if(idx === arr.length - 1){
                prev.avg = prev.sum / arr.length

                let highestCnt = 0
                Object.keys(prev.count).forEach(key => {
                    const count = prev.count[key]
                    if(count > highestCnt){
                        highestCnt = key
                    }
                })

                prev.mode = highestCnt
            }

            return prev
        }, {
            count: {},
            avg: 0,
            mode: 0,
            sum: 0,
            max: cityMarkers?.length > 0 ? cityMarkers[0].value : 0,
            min: cityMarkers?.length > 0 ? cityMarkers[0].value : 0
        })

        setState(prev => ({
            ...prev,
            cityMarkers,
            cityMarkerVals,
            cityDictionary
        }))

        onComplete({
            cityMarkers,
            cityDictionary
        })

    }, [cityMetrics])

    const { 
        markerTooltip, 
        mouseTooltipActive,
        cityMarkers,
        cityMarkerVals
    } = state

    return <div style={{position: "relative"}} className="text-center">
        <MouseTooltip
            key={"mouseTooltip"}
            className="mouseTooltip"
            visible={mouseTooltipActive}
            offsetX={0}
            offsetY={0}
            style={{zIndex:9999, position: "absolute", top: 50, left: 50}}>
            {markerTooltip}
        </MouseTooltip>
        {/* <div style={{zIndex:9999, position: "absolute", top: 50, right: 50}}>
            <div className="btn-group btn-group-lg">
                <button className="btn btn-secondary" onClick={handleZoomOut}>
                    <i class="fas fa-minus-circle"></i>
                </button>
                <button className="btn btn-primary" onClick={handleZoomIn}>
                    <i class="fas fa-plus-circle"></i>
                </button>
            </div>
        </div> */}
        <ComposableMap projection="geoAlbersUsa" style={{maxHeight: "750px", textAlign: "center"}}>
            <ZoomableGroup
                zoom={position.zoom}
                center={position.coordinates}
                onMoveEnd={handleMoveEnd}
                >
                <Geographies geography={geoUrl}>
                    {({geographies}) => geographies && geographies?.length > 0 ? geographies?.map(geo =>
                        <Geography key={geo.rsmKey} geography={geo} fill={useDarkMode ? "#DDD" : "#808080"} />
                    ): null}
                </Geographies>
                {cityMarkers.map(m => {
                    return <Marker coordinates= {[m.lng,m.lat]}
                        style={{
                            default: { fill: cityMarkerVals.mode < m.value ? "#04c142" : cityMarkerVals.mode > m.value ? "#007aff" : "#ff9500" },
                            hover: { fill: "#FFFFFF" },
                            pressed: { fill: "#FF5722" },
                        }}
                        onMouseEnter={() => {
                            setState(prev => ({
                                ...prev,
                                mouseTooltipActive: true,
                                markerTooltip: <span style={{fontSize: "14px"}} className={`badge badge-pill badge-dark`}>
                                    {m.name}: {m.value}
                                </span>
                            }))
                        }}
                        onMouseLeave={() => {
                            setState(prev => ({
                                ...prev,
                                mouseTooltipActive: false,
                                markerTooltip: ""
                            }))
                        }}
                        >
                        <circle
                            cx={0}
                            cy={0}
                            r={5}
                            style={{
                                stroke: cityMarkerVals.mode < m.value ? "#04c142" : cityMarkerVals.mode > m.value ? "#007aff" : "#ff9500",
                                strokeWidth: 3,
                                opacity: 0.9,
                            }}
                        />
                    </Marker>
                })}
            </ZoomableGroup>
        </ComposableMap>
    </div>
}

USAMap.defaultProps = {
    cityMetrics: [],
    onComplete: () => {}
}

export default USAMap